import { useState, useMemo } from 'react';

interface UseLocalPaginationProps<T> {
  items: T[];
  pageSize: number;
}

interface UseLocalPaginationReturn<T> {
  currentPageIndex: number;
  setCurrentPageIndex: (page: number) => void;
  paginatedItems: T[];
  totalPages: number;
}

export const useLocalPagination = <T>({
  items,
  pageSize,
}: UseLocalPaginationProps<T>): UseLocalPaginationReturn<T> => {
  const [currentPageIndex, setCurrentPageIndex] = useState(1);

  const { paginatedItems, totalPages } = useMemo(() => {
    const startIndex = (currentPageIndex - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedItems = items.slice(startIndex, endIndex);
    const totalPages = Math.ceil(items.length / pageSize);

    return { paginatedItems, totalPages };
  }, [items, currentPageIndex, pageSize]);

  return {
    currentPageIndex,
    setCurrentPageIndex,
    paginatedItems,
    totalPages,
  };
};
